export default class MapboxLinkMarkers {
  constructor(isLinked) {
    this.isLinked = isLinked;
  }

  onAdd(map) {
    const icon = $('<span>')
      .addClass('mapboxgl-ctrl-icon')
      .attr('aria-hidden', 'true');
    const toggleButton = $('<button>')
      .addClass('app-map-link-markers-toggle')
      .attr('type', 'button')
      .attr('title', 'Toggle')
      .attr('aria-label', 'Toggle')
      .html(icon);
    const container = $('<div>')
      .addClass('mapboxgl-ctrl mapboxgl-ctrl-group app-map-link-markers')
      .html(toggleButton);

    this._map = map;
    this._container = container.get(0);
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }

  toggleIsLinked() {
    this.isLinked = !this.isLinked;
    return this.isLinked;
  }

  toggleSelector() {
    return '.app-map-link-markers-toggle';
  }
}
